import { useQuery } from "@tanstack/react-query";
import { fetchSubstanceInventory } from "@/services/substance_api";
import type { SubstanceKind } from "@/utils/types/substance";

export function useSubstanceInventory(
  kind: SubstanceKind | null,
  id: number | null,
) {
  return useQuery({
    queryKey: ["substanceInventory", kind, id] as const,
    queryFn: ({ signal }) => fetchSubstanceInventory(kind!, id!, signal),
    enabled: kind !== null && id !== null,
    staleTime: 30_000,
  });
}
